export default __webpack_public_path__ + "static/media/url.8ad7d587.svg";